module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [_c('svg', {
    staticClass: "info-box-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "8949 -947 14.89 50"
    }
  }, [_c('path', {
    staticClass: "a",
    attrs: {
      "d": "M30.19,997.365a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,30.19,997.365Zm0,16.541H22.56l.012,3,5.89-.021v27.5H22.556l.006,2.952,7.628.01,7.255.018-.006-2.97-5.519-.01v-27.5c0-2.991.046-2.987-1.73-2.987Z",
      "transform": "translate(8926.444 -1944.365)"
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-text"
  }, [_vm._v("\n      Nous vous remercions de votre visite"), _c('br'), _vm._v("A bientôt !\n    ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-54259a90", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54259a90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Disconnect.vue
// module id = 195
// module chunks = 1